import type { Incoming } from "../types"
import IncomingList from "./IncomingList"
import Section from "./Section"

// Every order line on the way to this market, then those whose market is
// unknown. Hidden when nothing is on the way.
export default function IncomingSection({ incoming, today }: { incoming: Incoming; today: string }) {
  if (incoming.market.length === 0 && incoming.unknown.length === 0) return null

  return (
    <Section title="Incoming to this market">
      <IncomingList lines={incoming.market} today={today} empty="Nothing on the way to this market." />
      {incoming.unknown.length > 0 && (
        <div className="flex flex-col gap-1 border-t border-border pt-2">
          <div className="text-sm font-semibold text-foreground">Incoming, market unknown</div>
          <IncomingList lines={incoming.unknown} today={today} />
        </div>
      )}
    </Section>
  )
}
